import { Component } from '@angular/core';
import { BusinessSettings } from '@models/businessSettings/settings';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessDispatch, BusinessState } from '@state/business';
import { ButtonGroupOption } from '../../../shared/atomic/atoms/button-group/button-group.component';

@Component({
	selector: 'app-defaults',
	templateUrl: './defaults.component.html',
	standalone: false,
})
export class DefaultsComponent {
	public currentPage: string;
	public pages: ButtonGroupOption<string>[] = [
		{
			label: 'General',
			value: 'general',
			intercomAttr: 'general-defaults',
		},
		{
			label: 'Statement of Account',
			value: 'soac',
			intercomAttr: 'soac-defaults',
		},
		{
			label: 'Statement of Adjustments',
			value: 'soa',
			intercomAttr: 'soa-defaults',
		},
		{
			label: 'Trust Ledger',
			value: 'tl',
			intercomAttr: 'tl-defaults',
		},
	];

	@ViewSelectSnapshot(BusinessState.getDefaultSettings)
	settings: BusinessSettings;

	constructor(private businessDispatch: BusinessDispatch) {
		this.currentPage = 'general';
	}

	setCollapseSpouseSurnames($event: boolean): void {
		this.businessDispatch.UpdateDefaultSettings({
			collapseSpouseSurnames: $event,
		} as BusinessSettings);
	}
}
